/**********************************************************************************************************************/
/* FILE: hafas_webapp_controller_livemap.js                                                                           */
/**********************************************************************************************************************/
/* Controller.Livemap */

HafasWebapp.prototype.Controller.Livemap = {
  instance: null,
  jnyLoadingIndicator: null,
  currentJnyFltr: null,
  livemapContext: null,
  inactivityPopup: null,
  addLivemapButton: function(){
     this.livemapButton = this.main.Controller.Map.instance.addBtnControl({
         id: 'contextLivemap',
         position: 'topright',
         freepositioning: true,
         right: 0,
         top: 50,
         buttonClass: 'hfs_livemapBtn',
         iconClass: 'hfs_mapActionButton',
         iconClassActive: 'hfs_mapActionButtonActive',
         toggleContent: '',
         onclick: Hafas.bind(function(boolval){
             if(this.currentJnyFltr == null || boolval == false) {
               Hafas.ps.pub('/mobilityradar/journeys/setAllProductClass/webapp',[boolval]);
             }
             if(boolval == false) {
               Hafas.ps.pub("/livemap/clearJourneyFilter", [!boolval]);
               this.instance.stopanimation(true);
               this.instance.clearInactivityTimer();
             }else{
               this.instance.startInactivityTimer();
               if(this.currentJnyFltr != null){
                   if(this.instance == null){
                     Hafas.ps.pub('/mobilityradar/journeys/setAllProductClass/webapp',[boolval]);
                   }
                   Hafas.bind(this.setJourneyFilter, this.main)(this.currentJnyFltr.filterList, this.currentJnyFltr.options);
                   this.instance.updateLiveMap();
               }
             }
         },this)
     });
  },
  index: function(data){
     if(typeof this.Controller.Livemap.livemapButton == 'undefined') {
       this.Controller.Livemap.addLivemapButton();
     }
  },
  toggleVisibilityHint: function(boolval,id){
       if(Hafas('[data-zoom-hint="' + id + '"]')){
       if(boolval) {
           Hafas('[data-zoom-hint="' + id + '"]').removeClassName("hfs_visibilityHidden");
       }else{
           Hafas('[data-zoom-hint="' + id + '"]').addClassName("hfs_visibilityHidden");
       }
       }
  },
  toggleLivemap: function(boolval){
     if(boolval) {
         this.Controller.Livemap.startLivemap();
     }else{
         this.Controller.Livemap.stopLivemap();
     }
  },
  removeLivemapButton: function(){

  },
  startLivemap: function(){
      if(this.instance == null) {
         var mobilityRadarInstance = this.main.Controller.Map.mobilityRadar;
         var livemapProducts = mobilityRadarInstance.livemapSelectableProducts;
         var preSelection = 0;
         for(var p=0; p < livemapProducts.length;p++) {
             if((!livemapProducts[p].disabled) && (livemapProducts[p].checked)){
                preSelection += livemapProducts[p].bit;
             }
         }
         var livemapConfig = {
             map: this.main.Controller.Map.instance,
             shownames: true,
             pCls: preSelection,
             offsetTop: 0 // tempor�r bis bessere L�sung f�r das Problem "Fixed" Container zur Verf�gung steht
         };
         if(typeof Hafas.Config.Livemap != 'undefined') {
           if (typeof Hafas.Config.Livemap.iconSizes != 'undefined') {
             livemapConfig.iconSizes = Hafas.Config.Livemap.iconSizes;
           }
           if (typeof Hafas.Config.Livemap.trainPosMode != 'undefined') {
             livemapConfig.trainPosMode = Hafas.Config.Livemap.trainPosMode;
           }
           if (typeof Hafas.Config.Livemap.timeout != 'undefined') {
             livemapConfig.presentationTimer = Hafas.Config.Livemap.timeout;
           }
           if (typeof Hafas.Config.Livemap.showRouteOnClick != 'undefined') {
             livemapConfig.showRouteOnClick = Hafas.Config.Livemap.showRouteOnClick;
           }
         }
         this.instance = Hafas.Core.newType("hafasLivemap",livemapConfig);
      }
      this.livemapButton.setToggleStatus(true);
      this.instance.startanimation();
      Hafas.ps.pub('/tracking/screen/live-map-main', [ { typ: 'screen', key: 'live-map-main' } ]);
  },
  stopLivemap: function(){
      if(this.instance) {
          this.instance.stopanimation(true);
          this.livemapButton.setToggleStatus(false);
      }
  },
  getLivemapStatus: function(){
    if(typeof this.livemapButton != 'undefined' && this.livemapButton != null) {
    return this.livemapButton.getToggleStatus();
    }else{
      return false;
    }
  },
  updateFlyout: function(id){
      var htmlValidId = id.replace(/\|/g,"_");
      if(Hafas('#HFS_LivemapShowRoute_'+ htmlValidId,false) != null){
        Hafas('#HFS_LivemapShowRoute_'+ htmlValidId,false).setAttribute("aria-checked",true);
      }
  },
  updateLivemapContext: function(){
    var livemapActiveStatus = this.Controller.Livemap.getLivemapStatus();
    Hafas.ps.pub("/mobilityradar/journeys/setAllProductClass/webapp", [livemapActiveStatus, livemapActiveStatus]);
  },
  disableProduct: function(content,disableBool){
    var livemapInstance = this.Controller.Livemap.instance;
    var zoomHintContainer = Hafas('[data-zoom-hint="' + content.id + '"]');

    // Prüfen ob Follow Modus aktiv, dann soll nicht neu geholt werden
        var update = false;
      if (zoomHintContainer) {
        if (disableBool) {
        Hafas.Util.gui.setVisibility(zoomHintContainer, true);
        if(livemapInstance) {
            livemapInstance.setProductClass(content.bit, false, update);
        }
		 }else{
        if (livemapInstance && content.checked == true) {
              livemapInstance.setProductClass(content.bit, true, update);
            }
        Hafas.Util.gui.setVisibility(zoomHintContainer, false);
     }
    }
  },
  showRoute: function(jid,boolval){
       if(boolval) {
           Hafas.ps.pub('/tracking/event/mapflyout-highlight-liveroute-enabled', [ { typ: 'event', key: 'mapflyout-highlight-liveroute-enabled' } ]);
          this.Controller.Livemap.instance.showRoute(jid);
       }else{
           Hafas.ps.pub('/tracking/event/mapflyout-highlight-liveroute-disabled', [ { typ: 'event', key: 'mapflyout-highlight-liveroute-disabled' } ]);
          this.Controller.Livemap.instance.hideRoute(jid);
       }
  },
  followJourney: function(jid,boolval){
       if(boolval) {
           // Tracking
           Hafas.ps.pub('/tracking/event/mapflyout-followmode-enabled', [ { typ: 'event', key: 'mapflyout-followmode-enabled' } ]);
           this.Controller.Livemap.instance.setCurrentTrackId(jid);
       }else{
           // Tracking
           Hafas.ps.pub('/tracking/event/mapflyout-followmode-disabled', [ { typ: 'event', key: 'mapflyout-followmode-disabled' } ]);
           this.Controller.Livemap.instance.setCurrentTrackId(null);
       }
  },
  stopFollowJourney: function(){
      if(this.Controller.Livemap.instance) {
        var currTrackId = this.Controller.Livemap.instance.getCurrentTrackId();
        if(currTrackId != null){
          var followChbox = Hafas('[data-livemap-follow="' + currTrackId + '"]',false);
          if(followChbox){
             followChbox.checked = false;
          }
          this.Controller.Livemap.toggleFollowIndicator(currTrackId,false);
        }
        Hafas.bind(this.Controller.Livemap.followJourney, this)(null, false);
      }
  },
  zoomToJourney: function(id) {
    this.Controller.Livemap.instance.zoomToProduct(id);
  },
  updateLivemap: function(products, update){
      if(this.Controller.Livemap.instance != null) {
          for(var p=0; p < products.length;p++) {
              if(products[p].checked && !products[p].disabled) {
                 this.Controller.Livemap.instance.setProductClass(products[p].bit,true, update);
              }else{
                 this.Controller.Livemap.instance.setProductClass(products[p].bit,false, update);
              }
          }
          this.Controller.Livemap.instance.updateLiveMap();
      }
  },
  refresh: function(mapTriggered){
    var livemapInstance = this.Controller.Livemap.instance;
    if(livemapInstance) {
      if (livemapInstance.getCurrentTrackId() == null &&
          this.Controller.Livemap.getLivemapStatus() == true &&
          this.Controller.Livemap.instance.ignoreMapState == false
        ) {
        livemapInstance.stopanimation();
        livemapInstance.trainOverlay.draw();
        livemapInstance.startanimation();
      }
    }
  },
  showOnlyThisJourney: function(jid,boolval){
       if(boolval) {
           Hafas.ps.pub('/tracking/event/mapflyout-focus-liveroute-enabled', [ { typ: 'event', key: 'mapflyout-focus-liveroute-enabled' } ]);
         this.Controller.Livemap.instance.setExclusiveTrain(jid);
       }else{
           Hafas.ps.pub('/tracking/event/mapflyout-focus-liveroute-disabled', [ { typ: 'event', key: 'mapflyout-focus-liveroute-disabled' } ]);
         this.Controller.Livemap.instance.setExclusiveTrain(null);
       }
  },
  setJourneyFilter: function(filterList, options) {
    this.Controller.Livemap.currentJnyFltr = {
      filterList: filterList,
      options: options
    };
    var filter = [];
    for(var i = 0; i < filterList.length; i++)
    {
      filter.push({type:filterList[i].type, value:filterList[i].value, mode:filterList[i].mode || "INC"});
  }
    if(this.Controller.Livemap.instance != null) {
      this.Controller.Livemap.instance.setJourneyFilter(filter, options || {});
    }
  },
  clearJourneyFilter: function(update,deleteFilter) {
    if(this.Controller.Livemap.instance != null) {
      this.Controller.Livemap.instance.clearJourneyFilter(update || false);
    }
    if(typeof deleteFilter != 'undefined' && deleteFilter == true){
      this.Controller.Livemap.currentJnyFltr = null;
    }
    this.Controller.Livemap.livemapContext = null;
    if(this.Controller.Livemap.getLivemapStatus() == true) {
      Hafas.ps.pub('/mobilityradar/journeys/setAllProductClass/webapp', [true]);
    }
  },
  setCallbacks: function(params) {
    for(var name in params)
    {
      this.instance.setCallback(name, params[name]);
    }
  },
  openJourneyToolbox: function(trainId) {
    this.instance.openJourneyPopup(trainId);
  },
  openTrainroute: function(data){
     this.Controller.Livemap.livemapContext = 'tq';
     var polyBounds = this.Controller.Map.instance.getPolylineBounds(this.Controller.TQ.currentTrainroute.mapContent.centerPoly);
     if(typeof data.calledFrom == 'undefined'){
       Hafas.ps.pub('/livemap/setJourneyFilter', [[{ type:'JID', mode:'INC', value:data.jid}], {restart:true, ignoreMapState:true, customBoundingBox: polyBounds }]);
       Hafas.ps.pub('/map/closeToolboxItem', []);
       Hafas.ps.pub('/map/closeAllToolboxItems',[]);
     }
  },
  openTrainrouteFromLivemap: function(jid,boolChecked,trigger,event) {
    this.livemapContext = 'tq';
    var map = this.main.Controller.Map.instance;
    // PageContent muss wieder eingeblendet werden, da er zuvor im GUI Controller ausgeblendet wird
    if (this.main.layoutClass == "small") {
       Hafas('#'+this.main.mapContainer,false).style.zIndex = -1;
       Hafas.Util.gui.setVisibility(Hafas("#HFS_PageContent"), true);
    }


    var historyAddData = {
       boundingBox: map.getBoundingBox(),
       jid: jid,
       zoom: map.getZoom("api"),
       center: map.getCenter()
    };
    if(this.main.Controller.Livemap.currentJnyFltr != null){
      historyAddData.prevJnyFilter = Hafas.Core.clone(this.main.Controller.Livemap.currentJnyFltr);
    }

    Hafas.Modules.History.addAdditionalData("/livemap/closeTrainrouteFromLivemap", historyAddData);
    Hafas.ps.pub('/tq/showTrainroute',[{trigger: trigger, ev: event, jid: jid, independent: true , calledFrom: 'livemap'}]);
    Hafas.ps.pub('/livemap/setJourneyFilter', [[{ type:'JID', mode:'INC', value:jid}], {restart:true, ignoreMapState:true}]);
    Hafas.ps.pub('/map/closeToolboxItem', []);
    Hafas.ps.pub('/map/closeAllToolboxItems',[]);
    // Tracking
    Hafas.ps.pub('/tracking/event/mapflyout-routedetails-pressed', [ { typ: 'event', key: 'mapflyout-routedetails-pressed' } ]);
  },
  closeTrainrouteFromLivemap: function(data){
    if(typeof data.prevJnyFilter == 'undefined' || data.prevJnyFilter == null) {
      Hafas.ps.pub('/livemap/clearJourneyFilter', [true, true]);
    }else{
      Hafas.ps.pub('/livemap/setJourneyFilter', [data.prevJnyFilter.filterList, {restart:true, ignoreMapState:true}]);
    }
    this.main.Controller.Map.instance.centerToGeo(data.center,data.zoom);
    this.checkJourneyExistence(data.jid,0);
  },
  showContextLivemapTP: function(connection){
      this.Controller.Livemap.livemapContext = 'tp';
      // Verfolgung stoppen & Flyout schließen
      Hafas.bind(this.Controller.Livemap.stopFollowJourney,this)();
      Hafas.ps.pub('/map/closeToolboxItem', []);
      Hafas.ps.pub('/map/closeAllToolboxItems',[]);

      var fltrL = [];
      // Filter für Livemap raussuchen:
      for(var s=0; s < connection.secL.length;s++){
        if(typeof connection.secL[s].jny != 'undefined'){
           fltrL.push({ type:'JID', mode:'INC', value:connection.secL[s].jny.jid})
        }
      }
      Hafas.ps.pub('/livemap/setJourneyFilter', [fltrL, {restart: this.Controller.Livemap.getLivemapStatus(), ignoreMapState: true}]);
  },
  checkJourneyExistence: function(jid,attemptNo){
    var journeyExists = this.main.Controller.Livemap.instance.openJourneyPopup(jid);
    var livemap = this.main.Controller.Livemap.instance;
    if(!journeyExists){
       if(attemptNo < 10) {
         window.setTimeout(Hafas.bind(function () {
           this.checkJourneyExistence(jid, attemptNo + 1)
         }, this), 500);
  }
    }else{
      livemap.trainContainer[jid].selected = true;
      if(this.instance.currentTrainLaneId == jid){
         this.instance.showRoute(jid);
      }
    }
  },
  showLoadingIndicator: function(moduleName,hciService){
     var loadingIndicator = Hafas.Core.newType("HafasLoadingIndicator",{
        type:'bar',
        id: moduleName + '_' + hciService,
        attachTo: Hafas('#HFS_PageMapNotifications',false),
        content: Hafas.Modules.i18n.get('Livemap.t_N_loadJourneys')
     });
     Hafas.bind(this.Controller.Livemap.hideLoadingIndicator,this)();
     loadingIndicator.show();
     this.Controller.Livemap.jnyLoadingIndicator = loadingIndicator;
  },
  hideLoadingIndicator: function(moduleName,hciService){
    if(this.Controller.Livemap.jnyLoadingIndicator != null) {
      this.Controller.Livemap.jnyLoadingIndicator.hide();
      this.Controller.Livemap.jnyLoadingIndicator.remove();
      this.Controller.Livemap.jnyLoadingIndicator = null;
    }
  },
  toggleFollowIndicator: function(jid,boolval){
      var attachToDiv = Hafas('#HFS_PageMapNotifications',false);
      if(boolval){
         var content = Hafas.Modules.i18n.get('Livemap.t_N_followRoute');
         var id = 'livemap_followOn';
      }else{
         var content = Hafas.Modules.i18n.get('Livemap.t_N_followDeactivated');
         var id = 'livemap_followOff';
      }
      var loadingIndicator = Hafas.Core.newType("HafasLoadingIndicator",{
        type:'bar',
        id: id,
        attachTo: attachToDiv,
        content: content,
        expire: 3
      });
      loadingIndicator.show();
  },
  getLivemapContext: function(){
    return this.livemapContext;
  },
  updateInFollowMode: function(){
    if(this.Controller.Livemap.instance == null){
      return;
    }
    var trackId = this.Controller.Livemap.instance.getCurrentTrackId();
    if(trackId != null && this.Controller.Livemap.instance.getCurrentJourneyFollowedActive() == true){
       window.setTimeout(Hafas.bind(function() {
         Hafas.bind(this.Controller.Livemap.stopFollowJourney, this)();
       },this),500);
    }
  },
  showInactivityPopup: function(){
    // Hinweisfenster anzeigen, sofern nicht schon vorhanden
    var _me = this;
    if(_me.Controller.Livemap.inactivityPopup == null) {
      Hafas.Modules.Render.render({
        template: 'Common_AtomNotification',
        file: 'common.overlays.html',
        model: {}
      }, function (outputHTML) {
        _me.Controller.Livemap.inactivityPopup = Hafas.Core.newType("HafasOverlay", {
          app: _me,
          outputHTML: outputHTML,
          title: null,
          cssClass: 'lyr_livemapOverlay',
          onClose: function () {

          }
        });
      });
    }
  },
  resumeLivemap: function(){
      // Hinweisfenster schließen und Livemap fortsetzen
      var _me = this;
      _me.Controller.Livemap.inactivityPopup.close();
      _me.Controller.Livemap.inactivityPopup = null;
      _me.Controller.Livemap.instance.resume();
      _me.Controller.Livemap.instance.startInactivityTimer();
  }
};
